import { normalizeId } from "../utils";

export const scheduleKeys = {
  all: ["schedule"] as const,

  stripboard: (projectId: string | number, documentId: string | number) =>
    [...scheduleKeys.all, "stripboard", normalizeId(projectId), normalizeId(documentId)] as const,

  boneyard: (projectId: string | number, documentId: string | number) =>
    [...scheduleKeys.all, "boneyard", normalizeId(projectId), normalizeId(documentId)] as const,

  locations: (projectId: string | number, documentId: string | number) =>
    [...scheduleKeys.all, "locations", normalizeId(projectId), normalizeId(documentId)] as const,

  /** The scene list the shooting calendar offers when adding a scene to a day. */
  calendarScenes: (projectId: string | number, documentId: string | number) =>
    [
      ...scheduleKeys.all,
      "calendarScenes",
      normalizeId(projectId),
      normalizeId(documentId),
    ] as const,

  dayOutOfDays: (projectId: string | number, documentId: string | number) =>
    [...scheduleKeys.all, "dayOutOfDays", normalizeId(projectId), normalizeId(documentId)] as const,

  comments: (
    projectId: string | number,
    documentId: string | number,
    filters?: { status?: "open" | "resolved" }
  ) =>
    [
      ...scheduleKeys.all,
      "comments",
      normalizeId(projectId),
      normalizeId(documentId),
      filters?.status ?? null,
    ] as const,

  commentsDocumentScope: (projectId: string | number, documentId: string | number) =>
    [...scheduleKeys.all, "comments", normalizeId(projectId), normalizeId(documentId)] as const,
};
